export const environment = {
  production: true,
  buildId: '3061678870220251',
  configFile: 'config.json',
};
